import axios from "axios";
import { Baseurl } from "../baseurl";
import { toast } from "react-toastify";

export const fetchAuctionVehicles = async () => {
  try {
    const response = await axios.get(`${Baseurl}/api/vehicles/getVehicles/allTypeVehicles`);
    return response.data;
  } catch (err) {
    toast.error(`Failed to load vehicles`);
  }
};
